/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileHeaderData_geography = {
    readonly " $fragmentRefs": FragmentRefs<"ProfileLocation_geography">;
    readonly " $refType": "ProfileHeaderData_geography";
};
export type ProfileHeaderData_geography$data = ProfileHeaderData_geography;
export type ProfileHeaderData_geography$key = {
    readonly " $data"?: ProfileHeaderData_geography$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileHeaderData_geography">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileHeaderData_geography",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProfileLocation_geography"
    }
  ],
  "type": "Geography",
  "abstractKey": null
};
(node as any).hash = 'a4f7441dbcf8c2c75975c0a299210c8c';
export default node;
